import { create } from "zustand";

import axios from "../helper/axios";

const useGlobalQCEStore = create((set) => ({
  newglobalEVID: null,
  allGlobalEvals: null,
  allGlobalEvalsPagination: null,
  selectedGlobalEvalQuestions: null,
  // allJDEvalsStats:null,
  selectedGloablEvalQuestions: null,
  globalUpdateFlagQ: false,
  globalUpdateFilterFlag: false,
  globalQuestionBankDB: null,
  globalQuestionBankDbStats: null,
  globalEvalStats: null,
  globalEvalCategoryStats: null,
  globaldomainArr: null,
  globalTotalQ: 0,
  globalAllEvalCategory: null,

  CreateNewGlobalEval: async (body) => {
    try {
      console.log(body);
      var userData = JSON.parse(localStorage.getItem("userDetails"));
      const response = await axios.post(
        `/nujobs/${userData.qhoid}/evaluations`,
        body.jasonValues,
      );
      set({ newglobalEVID: response.data.data, updateFlagQ: true });

      console.log(response.data);
    } catch (error) {
      set({ jdCreationError: error });
    }
  },

  updateGlobalEval: async (body, ev_id) => {
    try {
      console.log(body);
      var userData = JSON.parse(localStorage.getItem("userDetails"));
      const response = await axios.put(
        `/nujobs/${userData.qhoid}/evaluations/${ev_id}`,
        body.jasonValues,
      );
      set({ newglobalEVID: response.data.data, updateFlagQ: true });

      console.log(response.data);
    } catch (error) {
      set({ jdCreationError: error });
    }
  },

  getAllGlobalEvals: async (body) => {
    try {
      console.log("getAllGlobalEvals");
      var userData = JSON.parse(localStorage.getItem("userDetails"));
      const response = await axios.get(`/nujobs/evaluations/list`, {
        params: {
          state: body?.state || "",
          duration: body?.duration || "",
          skill: body?.skill || "",
          page: body?.page || 1,
          limit: body?.limit || 12,
        },
      });
      console.log("All Evals Global", response.data);
      //console.log(response.data.data);
      //console.log(response.data.eStatsArr);

      set({
        allGlobalEvals: response?.data.data,
        allGlobalEvalsPagination: response?.data.pagination,
        //  allJDEvalsStats: response?.data.stats,
        selectedGloablEvalQuestions: response?.data.questions,
        globalUpdateFilterFlag: false,
        globalUpdateFlagQ: false,
      });
    } catch (err) {
      console.log("Evals Data Error", err);
      console.log(err.response.data.jd);
      console.error(err);
    }
  },

  AddQuestionsToGlobalQBank: async (body) => {
    try {
      console.log(body.jasonValues);
      var userData = JSON.parse(localStorage.getItem("userDetails"));
      const response = await axios.post(
        `/nujobs/${userData.qhoid}/questions`,
        body.jasonValues,
      );
      console.log(response.data);
    } catch (error) {
      set({ jdCreationError: error });
    }
  },

  LinkQuestionsToGlobalEval: async (body) => {
    try {
      console.log(body.jasonValues);
      var userData = JSON.parse(localStorage.getItem("userDetails"));
      const response = await axios.post(
        `/nujobs/${userData.qhoid}/evaluations/${body.ev_id}/questions`,
        body.jasonValues,
      );
      console.log(response.data);
    } catch (error) {
      set({ jdCreationError: error });
    }
  },

  getGlobalQuestionBank: async (setLocalQSet, setQbCount, setQbStats) => {
    var userData = JSON.parse(localStorage.getItem("userDetails"));
    const response = await axios.get(
      `/nujobs/${userData.qhoid}/questions/list`,
    );
    set({ globalQuestionBankDB: response.data.data });
    console.log("getGlobalQuestionsBank", response.data.data);
    if (setLocalQSet != null) {
      if (response.data.data == null) {
        setLocalQSet([]);
        setQbCount(0);
      } else {
        setLocalQSet([...response.data.data]);
        setQbCount(response.data.totalQ);
        setQbStats(response.data.statistics);
      }
    }
  },

  getQuestionsForEvaluation: async (evaluation_id) => {
    var userData = JSON.parse(localStorage.getItem("userDetails"));
    const response = await axios.get(`/nujobs/evaluations/${evaluation_id}`);
    set({ selectedGlobalEvalQuestions: response.data.questions });
  },

  updateGlobalEvalState: async (evalState) => {
    try {
      console.log(evalState);
      var userData = JSON.parse(localStorage.getItem("userDetails"));
      const response = await axios.patch(
        `/nujobs/${userData.qhoid}/evaluations/${evalState.ev_id}/state`,
        evalState.body,
      );
      console.log(response.data);
    } catch (error) {
      set({ jdCreationError: error });
    }
  },
}));

export default useGlobalQCEStore;
